module.exports = __webpack_public_path__ + "media/ring.3d32482e.mp4";